import { z } from 'zod'

import { guidanceFieldFeaturesSchema } from '../geojson-schemas'

const polygonCoordinatesSchema = z.array(z.array(z.unknown()).min(4)).min(1)

const geometryShapeSchema = z.object({
  geometry: z.object({ type: z.string(), coordinates: z.unknown() }).optional()
})

const featureListSchema = z.looseObject({ features: z.array(z.unknown()) })

const hasWellFormedRings = (feature: unknown): boolean => {
  const shape = geometryShapeSchema.safeParse(feature)
  if (!shape.success || shape.data.geometry === undefined) return true
  const { type, coordinates } = shape.data.geometry
  if (type === 'Polygon') return polygonCoordinatesSchema.safeParse(coordinates).success
  if (type === 'MultiPolygon') {
    return z.array(polygonCoordinatesSchema).safeParse(coordinates).success
  }
  return true
}

const scrubDegenerateFeatures = (body: unknown): unknown => {
  const collection = featureListSchema.safeParse(body)
  if (!collection.success) return body
  return { ...collection.data, features: collection.data.features.filter(hasWellFormedRings) }
}

/**
 * The feature collection helm's guidance endpoints return. Helm sometimes
 * emits polygon features whose ring has fewer than four positions, and one
 * such feature would fail the whole parse, so those are dropped first.
 */
export const helmFieldFeaturesResponseSchema = z.preprocess(
  scrubDegenerateFeatures,
  guidanceFieldFeaturesSchema
)
